import {
  UseOfForceAuthorizationDecisionMaker,
  UseOfForceAuthorizationType,
} from '../../../../api-service/clients';

// Mirrors the module's rules so the form can guide; the module validates.
export function maxPeriodMonths(
  authorizationType: UseOfForceAuthorizationType
): number {
  return authorizationType === UseOfForceAuthorizationType.Section128 ? 18 : 12;
}

export function decisionMakerFor(
  authorizationType: UseOfForceAuthorizationType
): UseOfForceAuthorizationDecisionMaker {
  return [
    UseOfForceAuthorizationType.Section128bSubsection1,
    UseOfForceAuthorizationType.Section128g,
    UseOfForceAuthorizationType.Section128h,
  ].includes(authorizationType)
    ? UseOfForceAuthorizationDecisionMaker.SocialBoard
    : UseOfForceAuthorizationDecisionMaker.MunicipalCouncil;
}
